import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';
import './styles/base.css';

createApp(App).use(router).mount('#app');

/**
 * Register the offline shell.
 *
 * Only in a real build: the dev server has no `/sw.js`, and a worker that caches Vite's module
 * graph makes every subsequent edit invisible until someone thinks to unregister it.
 */
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // A refused registration is not a failure worth interrupting anyone over — private mode
      // and insecure origins both do it, and the app works perfectly well online without it.
    });
  });
}
